
import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default function VaultIcon(props) {
  return (
    <SvgIcon {...props}>
      <path
        d="M 12,3 A 9,2.5 0 0 0 3,5.5 9,2.5 0 0 0 12,8 9,2.5 0 0 0 21,5.5 9,2.5 0 0 0 12,3 Z m -9,4.5 0,4 a 9,2.5 0 0 0 9,2.5 9,2.5 0 0 0 9,-2.5 l 0,-4 A 9,2.5 0 0 1 12,10 9,2.5 0 0 1 3,7.5 Z m 0,6 0,4 a 9,2.5 0 0 0 9,2.5 9,2.5 0 0 0 9,-2.5 l 0,-4 A 9,2.5 0 0 1 12,16 9,2.5 0 0 1 3,13.5 Z" />
    </SvgIcon>);
}
